<template>
  <section>
    <v-btn color="primary" dark @click.stop="dialog = true">
      Adicionar Parametro Técnico
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline green darken-2 white--text" primary-title>
          Adicionar Parametro Técnico
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-select
              :items="technicalParameters"
              v-model="technicalParameter"
              label="Digite para buscar e selecione uma opção"
              item-text="name"
              item-value="value"
              return-object
              autocomplete></v-select>

            <v-radio-group v-model="technicalParameterType">
              <v-radio
                v-for="tpt in technicalParameterTypes"
                :key="tpt.value"
                :label="tpt.name"
                :value="tpt.value"
              ></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="addTechnicalParameter()">Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>

import TechnicalParametersService from '@/services/applications/configurations/TechnicalParameterService';

export default {
  name: 'AddTechnicalParameter',
  components: {},
  props: ['typologyId'],
  mounted() {
    TechnicalParametersService
      .fetchTechnicalParameters()
      .then((response) => {
        this.technicalParameters = response.data;
      });
    // .catch((error) => {
    //   console.log(error);
    // });
  },
  data() {
    return {
      requiredRules: [
        v => !!v || 'Campo Obrigatório',
      ],
      dialog: false,
      valid: false,
      technicalParameters: [],
      technicalParameter: {},
      technicalParameterType: '',
      technicalParameterTypes: [
        { name: 'Taxa e Estudo Técnico', value: 'tax_technical_study' },
        { name: 'Estudo Técnico', value: 'technical_study' },
      ],
    };
  },
  methods: {
    addTechnicalParameter() {
      const vm = this;

      const technicalParametersParams = {
        technical_parameter_id: vm.technicalParameter.id,
        technical_parameter_type: vm.technicalParameterType,
      };
      TechnicalParametersService
        .addTechnicalParameterToTypology(vm.typologyId, technicalParametersParams)
        .then((response) => {
          vm.$swal({
            title: 'Parametro Técnico adicionado com sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.technicalParameter = {};
            vm.$emit('technical-parameter-added', response.data);
            vm.dialog = false;
          });
        })
        .catch((error) => {
          vm.$swal({
            title: error.response.data.join(', '),
            type: 'error',
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
